import { render, staticRenderFns } from "./ReferralListTab.vue?vue&type=template&id=763ecd5b&"
import script from "./ReferralListTab.vue?vue&type=script&lang=ts&"
export * from "./ReferralListTab.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralListTab.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports